<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-angel"></i> Usuários Anjo <small>Listagem de Usuários Anjo</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-angel"></i> Usuários Anjo</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title"> Listagem de Usuários Anjo</h3>

                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <router-link class="btn btn-app" :to="{ name: 'form-user', params: { id: 0 }}">
                                <i class="fas fa-angel"></i> Cadastrar Usuário Anjo
                            </router-link>
                        </div>
                        <client-table :options="options">
                            <thead>
                                <tr>
                                    <th class="min-tablet" style="width: 70px;">Ativo</th>
                                    <th class="min-tablet text-center" style="width: 70px;">Status</th>
                                    <th>Nome</th>
                                    <th>E-mail</th>
                                    <th>Telefone</th>
                                    <th style="width: 150px;">Data Cadastro</th>
                                    <th class="min-tablet" style="width: 70px;">Ações</th>
                                </tr>
                            </thead>
                        </client-table>
                    </div>
                    <div class="card-footer">
                    </div>
                    <div class="overlay">
                        <a class="btn btn-app bg-secondary">
                            <i class="fas fa-spinner fa-pulse"></i> carregando...
                        </a>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
import format from 'date-fns/format';

export default {
    data: function () {
        const emergencyStatus = this.$route.query.emergencyStatus;
        return {
            options: {
                "title": "Usuários Anjo",
                "ajax": {
                    "url": "/api/user/datatable",
                    "data": function (d) {
                        return JSON.stringify($.extend({}, d, {
                            params: {
                                "emergencyStatus": emergencyStatus
                            }
                        }));
                    }
                },
                "createdRow": function (row, data) {
                    if (data.is_user_active == false) {

                        $(row).css({
                            "background-color": "#ccc"
                        });

                        $(row).find("td").css({
                            "text-decoration": "line-through",
                            "color": "#999",
                        });
                    }
                },
                "order": [[0, "desc"], [2, "asc"]],
                "columns": [
                    {
                        "bSortable": true,
                        "searchable": false,
                        "visible": false,
                        "mData": "is_user_active",
                        "sClass": "text-center py-0",
                        "mRender": function (data) {
                            if (data == true)
                                return '<span class="badge badge-success">Ativo</span>';
                            else
                                return '<span class="badge badge-danger">Inativo</span>';
                        }
                    },
                    {
                        "bSortable": true,
                        "searchable": true,
                        "mData": "emergencyStatus",
                        "sClass": "text-center py-0",
                        "mRender": function (data) {
                            switch (data) {
                                case 0:
                                    return '<span class="badge badge-success">Em Segurança</span>';
                                case 1:
                                    return '<span class="badge badge-warning">Em Alerta</span>';
                                case 2:
                                    return '<span class="badge badge-danger">Em Pânico</span>';
                                case 3:
                                    return '<span class="badge badge-secondary">Em Emergência</span>';
                                default:
                                    return '<span class="badge badge-success">Em Segurança</span>';
                            }   
                        }
                    },
                    { "mData": 'name' },
                    { "mData": 'email' },
                    { "mData": 'telefone' },
                    {
                        "bSortable": true,
                        data: 'data_cadastro',
                        "mRender": function (data) {
                            return data ? format(new Date(data),'dd/MM/yyyy hh:mm') : null;
                        }
                    }, 
                    {
                        "bSortable": false,
                        "mData": null,
                            "sClass": "text-center py-0",
                                "mRender": function (data, type, full) {
                                    return `<div class="btn-group">
                                        <button onclick="$(this).trigger('view', ${full.id_user})" rel="tooltip" title="Ver" class="btn bg-gradient-primary btn-sm"><i class="fas fa-search"></i></button>
                                        <button onclick="$(this).trigger('edit', ${full.id_user})" rel="tooltip" title="Editar" class="btn bg-gradient-primary btn-sm"><i class="fas fa-pencil-alt"></i></button>
                                    </div>`;
                                }
                    }
                ]
            }
        };
    },
    mounted: function () {
        const vm = this;
        $("body").on("edit", function (event, id) { vm.$router.push({ name: 'form-user', params: { id: id } }).catch(() => { }); });
        $("body").on("view", function (event, id) { vm.$router.push({ name: 'view-user', params: { id: id } }).catch(() => { }); });
    }
};
</script>

<style scoped>
</style>